export default "__VITE_ASSET__DG5DinQF__"